<template>
  <div id="week-top">
    <h1>{{ week }}</h1>
    <h2>
      <i v-if="diff === 0" class="anyteachicon anyteach-success blue" />
      <i v-else class="anyteachicon anyteach-jindu op" />
      <span>{{ complete }}/{{ homework.length }}</span>
    </h2>
    <p class="op">
      <i class="anyteachicon anyteach-quote" />
      {{ statement }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["start", "end", "homework"],
  computed: {
    week() {
      if (this.$moment().isAfter(this.start, "year")) {
        return `${this.start.format("YYYY年M月D日")}-${this.end.format("M月D日")}`
      } else {
        return `${this.start.format("M月D日")}-${this.end.format("M月D日")}`
      }
    },
    complete() {
      return this.homework.filter(item => item.status === 2).length
    },
    diff() {
      return this.homework.length - this.complete
    },
    statement() {
      if (this.complete === 0) {
        return "下周尝试完成作业，你会更棒的"
      } else if (this.diff === 0) {
        return "全部完成，真棒！"
      } else if (this.diff === 1) {
        return "只差一点点哦，下周加油！"
      } else {
        return "再接再厉，下周会更好！"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
#week-top {
  text-align: center;
  padding: 20px 0 10px 0;
  h1 {
    font-size: 1.25rem;
    line-height: 1.5;
  }
  h2 {
    font-size: 1rem;
    font-weight: 400;
    i {
      margin-right: 3px;
    }
    span {
      opacity: 0.6;
    }
  }
  p {
    padding: 15px 0 0 0;
    font-size: 1.1rem;
    i {
      font-size: 13px;
      transform: translateY(-10px);
      display: inline-block;
      margin-right: 3px;
    }
  }
}
</style>